import { HTMLAttributes } from 'react';
import { sortYoutubeVideo } from '@/website/util/video';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerInsuranceCoveragesViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    insuranceCoveragesTitle: string;
    insuranceCoveragesDesc: string;
    insuranceCoveragesList: Array<{ value: string; label: string }>;
    insuranceCoveragesVideoUrl: string;
    insuranceCoveragesMoreText: string;
  };
};
const VideoView = (props: BrokerInsuranceCoveragesViewProps) => {
  const { info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col overflow-hidden rounded-2xl', isMobileLayout ? 'h-auto w-full' : 'h-[300px] w-[450px]')}>
      <iframe
        className="iframeBorder aspect-video h-full w-full"
        src={sortYoutubeVideo(info?.insuranceCoveragesVideoUrl)}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen={true}
      ></iframe>
    </Box>
  );
};
const BrokerInsuranceCoveragesView = (props: BrokerInsuranceCoveragesViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex flex-col space-y-2', isMobileLayout ? 'w-full' : 'w-[960px]')}>
        <Box className={clsx('flex items-center', isMobileLayout ? 'w-full flex-col space-y-8 pt-4' : 'w-[960px] flex-row space-x-16')}>
          {isMobileLayout && <VideoView info={info} />}
          <Box className={clsx('flex flex-1 flex-col space-y-4', isMobileLayout ? 'mt-4 px-2' : 'my-16')}>
            <Typography variant="h4" className="text-primary-black font-serif font-black">
              {info?.insuranceCoveragesTitle}
            </Typography>
            <Typography variant="h6" className="text-primary-black font-medium leading-7">
              {info?.insuranceCoveragesDesc}
            </Typography>
          </Box>
          {!isMobileLayout && <VideoView info={info} />}
        </Box>
        <Box className={clsx('flex w-full gap-4', isMobileLayout ? 'flex-col' : 'flex-row')}>
          {(info?.insuranceCoveragesList || []).map((item, index) => {
            return (
              <Box key={index} className={clsx('flex h-[72px] items-center justify-center rounded-2xl bg-white', isMobileLayout ? '' : 'flex-1')}>
                <Typography variant="h6" className="text-brand-secondary font-bold">
                  {item.label}
                </Typography>
              </Box>
            );
          })}
          <Box className="flex h-[72px] items-center justify-center rounded-2xl bg-[#E7ECFF] px-8">
            <Typography variant="h6" className="text-primary-black font-bold">
              + {info?.insuranceCoveragesMoreText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerInsuranceCoveragesView;
